import { IDWarehouseLookupLayout } from "../../../common/lookups/Layouts/IdLayouts";
import { CodeLookupLayout, IMLocationLookupLayout, LocationDpLookupLayout } from "../../../common/lookups/Layouts/ImLayouts";
import { WMCodesLookupLayout } from "../../../common/lookups/Layouts/WMLayouts";
import { IM, WM } from "../../../const/constants";
const runtimeParameter = JSON.stringify([
    { RWarehouse: 'RWarehouse' }]);
const locationLookupLayout = IMLocationLookupLayout({ moduleType: IM, runtimeParameter })

const SearchLayout = [
    {
        "groupId": 1,
        "fields": [
            {
                "name": "IdentityId",
                "tableName": "IMLOCATION",
                "label": "Warehouse",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "CapacityUnits",
                "tableName": "IMLOCATION",
                "label": "Capacity Units",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "Status",
                "tableName": "IMLOCATION",
                "label": "Status",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "fields": [
            {
                "name": "LocationCode",
                "tableName": "IMLOCATION",
                "label": "Location",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "CapacityShippingUnits",
                "tableName": "IMLOCATION",
                "label": "Capacity Shipping Units",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ClassCode",
                "tableName": "IMLOCATION",
                "label": "Class",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "LocationType",
                "tableName": "IMLOCATION",
                "label": "Location Type",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "fields": [
            {
                "name": "Dimensions",
                "tableName": "IMLOCATION",
                "label": "Dimensions",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "CapacityArea",
                "tableName": "IMLOCATION",
                "label": "Capacity Area",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "SubClassCode",
                "tableName": "IMLOCATION",
                "label": "Sub Class",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            }, {
                "name": "CapacityContainerUnits",
                "tableName": "IMLOCATION",
                "label": "Capacity Container Units",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 4,
        "fields": [
            {
                "name": "CapacityPieces",
                "tableName": "IMLOCATION",
                "label": "Capacity Pieces",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {

                "name": "Description",
                "tableName": "IMLOCATION",
                "label": "Description",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {

                "name": "LastUpdatedDateTime",
                "tableName": "IMLOCATION",
                "label": "Last Updated DateTime",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            }, {

                "name": "CapacityGrossWeight",
                "tableName": "IMLOCATION",
                "label": "CapacityGrossWeight",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "LocationCode",
                "tableName": "IMLOCATION",
                "label": "Location",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "Description",
                "tableName": "IMLOCATION",
                "label": "Description",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "MinPositionIndex",
                "tableName": "IMLOCATION",
                "label": "Min Position Index",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "MaxPositionIndex",
                "tableName": "IMLOCATION",
                "label": "Max Position Index",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "CapacityAreaLimitFlag",
                "tableName": "IMLOCATION",
                "label": "Area",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },

            {
                "name": "CapacityVolume",
                "tableName": "IMLOCATION",
                "label": "Capacity Volume",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },


            {
                "name": "UserDefinedCode1",
                "tableName": "IMLOCATION",
                "label": "Code 1",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedCode2",
                "tableName": "IMLOCATION",
                "label": "Code 2",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedCode3",
                "tableName": "IMLOCATION",
                "label": "Code 3",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedCode4",
                "tableName": "IMLOCATION",
                "label": "Code 4",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedCode5",
                "tableName": "IMLOCATION",
                "label": "Code 5",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedCode6",
                "tableName": "IMLOCATION",
                "label": "Code 6",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedCode7",
                "tableName": "IMLOCATION",
                "label": "Code 7",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedCode8",
                "tableName": "IMLOCATION",
                "label": "Code 8",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedCode9",
                "tableName": "IMLOCATION",
                "label": "Code 9",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedCode10",
                "tableName": "IMLOCATION",
                "label": "Code 10",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },

            {
                "name": "UserDefinedDate1",
                "tableName": "IMLOCATION",
                "label": "Date 1",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedDate2",
                "tableName": "IMLOCATION",
                "label": "Date 2",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedDate3",
                "tableName": "IMLOCATION",
                "label": "Date 3",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedDate4",
                "tableName": "IMLOCATION",
                "label": "Date 4",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedDate5",
                "tableName": "IMLOCATION",
                "label": "Date 5",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedDate6",
                "tableName": "IMLOCATION",
                "label": "Date 6",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedDate7",
                "tableName": "IMLOCATION",
                "label": "Date 7",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedDate8",
                "tableName": "IMLOCATION",
                "label": "Date 8",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedDate9",
                "tableName": "IMLOCATION",
                "label": "Date 9",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedDate10",
                "tableName": "IMLOCATION",
                "label": "Date 10",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "Depth",
                "tableName": "IMLOCATION",
                "label": "Depth",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "ProfileDescription",
                "tableName": "IMLOCATION",
                "label": "Description",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },

            {
                "name": "Height",
                "tableName": "IMLOCATION",
                "label": "Height",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "LastUpdatedDateTime",
                "tableName": "IMLOCATION",
                "label": "Last Updated Date",
                "type": "datetime",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "LastUpdateUserId",
                "tableName": "IMLOCATION",
                "label": "Last Update By",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },

            {
                "name": "MinimumUnits",
                "tableName": "IMLOCATION",
                "label": "Minimum Units",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "MaximumUnits",
                "tableName": "IMLOCATION",
                "label": "Maximum Units",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "ParentLocation",
                "tableName": "IMLOCATION",
                "label": "Parent Location",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "ParentLocationDescription",
                "tableName": "IMLOCATION",
                "label": "Parent Location Description",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "CapacityPieces",
                "tableName": "IMLOCATION",
                "label": "Pieces",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "CapacityPiecesLimitFlag",
                "tableName": "IMLOCATION",
                "label": "Pieces",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "ProfileCode",
                "tableName": "IMLOCATION",
                "label": "Profile",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedQuantity1",
                "tableName": "IMLOCATION",
                "label": "Quantity 1",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedQuantity2",
                "tableName": "IMLOCATION",
                "label": "Quantity 2",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedQuantity3",
                "tableName": "IMLOCATION",
                "label": "Quantity 3",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedQuantity4",
                "tableName": "IMLOCATION",
                "label": "Quantity 4",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedQuantity5",
                "tableName": "IMLOCATION",
                "label": "Quantity 5",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedQuantity6",
                "tableName": "IMLOCATION",
                "label": "Quantity 6",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedQuantity7",
                "tableName": "IMLOCATION",
                "label": "Quantity 7",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedQuantity8",
                "tableName": "IMLOCATION",
                "label": "Quantity 8",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedQuantity9",
                "tableName": "IMLOCATION",
                "label": "Quantity 9",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedQuantity10",
                "tableName": "IMLOCATION",
                "label": "Quantity 10",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "Record",
                "tableName": "IMLOCATION",
                "label": "Record#",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedReference1",
                "tableName": "IMLOCATION",
                "label": "Reference 1",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedReference2",
                "tableName": "IMLOCATION",
                "label": "Reference 2",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedReference3",
                "tableName": "IMLOCATION",
                "label": "Reference 3",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedReference4",
                "tableName": "IMLOCATION",
                "label": "Reference 4",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedReference5",
                "tableName": "IMLOCATION",
                "label": "Reference 5",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedReference6",
                "tableName": "IMLOCATION",
                "label": "Reference 6",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedReference7",
                "tableName": "IMLOCATION",
                "label": "Reference 7",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedReference8",
                "tableName": "IMLOCATION",
                "label": "Reference 8",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedReference9",
                "tableName": "IMLOCATION",
                "label": "Reference 9",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "UserDefinedReference10",
                "tableName": "IMLOCATION",
                "label": "Reference 10",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "Status",
                "tableName": "IMLOCATION",
                "label": "Status",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "CapacityVolumeLimitFlag",
                "tableName": "IMLOCATION",
                "label": "Volume",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "Width",
                "tableName": "IMLOCATION",
                "label": "Width",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "CapacityLimitFlag",
                "tableName": "IMLOCATION",
                "label": "Capacity Limit",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },

            {
                "name": "CapacityContainerLimitFlag",
                "tableName": "IMLOCATION",
                "label": "Capacity Container Limit",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "CapacityShippingUnits",
                "tableName": "IMLOCATION",
                "label": "Capacity Shipping Units",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "CapacityShippingUnitsLimitFlag",
                "tableName": "IMLOCATION",
                "label": "Capacity Shipping Units Limit",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "CapacityGrossWeight",
                "tableName": "IMLOCATION",
                "label": "Capacity Gross Weight",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "CapacityGrossWeightLimitFlag",
                "tableName": "IMLOCATION",
                "label": "Capacity Gross Weight Limit",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "CapacityNetWeight",
                "tableName": "IMLOCATION",
                "label": "Capacity Net Weight",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "CapacityNetWeightLimitFlag",
                "tableName": "IMLOCATION",
                "label": "Capacity Net Weight Limit",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            },
            {
                "name": "Priority",
                "tableName": "IMLOCATION",
                "label": "Priority",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,

            }

        ]
    }
];
const PrimaryLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "Record",
                "tableName": "IMLOCATION",
                "label": "Record #",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },
            {
                "name": "RProfile",
                "tableName": "IMLOCATION",
                "label": "Profile",
                "type": "lookup",
                layout: LocationDpLookupLayout({moduleType: WM}),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RWarehouse",
                "tableName": "IMLOCATION",
                "label": "Warehouse",
                "type": "lookup",
                layout: IDWarehouseLookupLayout,
                "lookupDisplayMode": "grid",
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "LocationCode",
                "tableName": "IMLOCATION",
                "label": "Location",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "Description",
                "tableName": "IMLOCATION",
                "label": "Description",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "Status",
                "tableName": "IMLOCATION",
                "label": "Status",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "LocationType",
                "tableName": "IMLOCATION",
                "label": "Location Type",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "RLocation",
                "tableName": "IMLOCATION",
                "label": "Parent Location",
                "type": "lookup",
                layout: locationLookupLayout,
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "Priority",
                "tableName": "IMLOCATION",
                "label": "Priority",
                "type": "lookup",
                layout: WMCodesLookupLayout({ codeType: '84' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "searchEnabled": true,
                "acceptCustomValue": true,
            }, {
                "name": "ClassCode",
                "tableName": "IMLOCATION",
                "label": "Class",
                "type": "lookup",
                layout: WMCodesLookupLayout({ codeType: '72' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "acceptCustomValue": true,
            }, {
                "name": "SubClassCode",
                "tableName": "IMLOCATION",
                "label": "Sub Class",
                "type": "lookup",
                layout: WMCodesLookupLayout({ codeType: '73' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "acceptCustomValue": true,
            }, {
                "name": "PickSequence",
                "tableName": "IMLOCATION",
                "label": "Pick Seq",
                "type": "number",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "Comment",
                "tableName": "IMLOCATION",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    }
]
const DimensionTabLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "Dimensions",
                "tableName": "IMLOCATION",
                "label": "DIMENSIONS",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "Height",
                "tableName": "IMLOCATION",
                "label": "Height",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "Width",
                "tableName": "IMLOCATION",
                "label": "Width",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "Depth",
                "tableName": "IMLOCATION",
                "label": "Depth",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "Area",
                "tableName": "IMLOCATION",
                "label": "Area",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "Volume",
                "tableName": "IMLOCATION",
                "label": "Volume",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "MinPositionIndex",
                "tableName": "IMLOCATION",
                "label": "Min Position Index",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "MaxPositionIndex",
                "tableName": "IMLOCATION",
                "label": "Max Position Index",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    }, {
        "groupId": 2,
        "label": "Limit",
        "fields": [
            {
                "name": "CapacityLimitFlag",
                "tableName": "IMLOCATION",
                "label": "Inventory",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "CapacityPiecesLimitFlag",
                "tableName": "IMLOCATION",
                "label": "Pieces",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "CapacityShippingUnitsLimitFlag",
                "tableName": "IMLOCATION",
                "label": "Units/Pkg",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "CapacityContainerLimitFlag",
                "tableName": "IMLOCATION",
                "label": "Pkg/Ship",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "CapacityGrossWeightLimitFlag",
                "tableName": "IMLOCATION",
                "label": "Gross Weight",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "CapacityNetWeightLimitFlag",
                "tableName": "IMLOCATION",
                "label": "Net Weight",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "CapacityAreaLimitFlag",
                "tableName": "IMLOCATION",
                "label": "Area",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "CapacityVolumeLimitFlag",
                "tableName": "IMLOCATION",
                "label": "Volume",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    }, {
        "groupId": 3,
        "label": "Capacity",
        "fields": [
            {
                "name": "CapacityUnits",
                "tableName": "IMLOCATION",
                "label": "Inventory",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "CapacityPieces",
                "tableName": "IMLOCATION",
                "label": "Pieces",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "CapacityShippingUnits",
                "tableName": "IMLOCATION",
                "label": "Units/Pkg",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "CapacityContainerUnits",
                "tableName": "IMLOCATION",
                "label": "Pkg/Ship",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "CapacityGrossWeight",
                "tableName": "IMLOCATION",
                "label": "Gross Weight",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "CapacityNetWeight",
                "tableName": "IMLOCATION",
                "label": "Net Weight",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "CapacityArea",
                "tableName": "IMLOCATION",
                "label": "Area",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "CapacityVolume",
                "tableName": "IMLOCATION",
                "label": "Volume",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 4,
        "label": "Used",
        "fields": [
            {
                "name": "",
                "tableName": "IMLOCATION",
                "label": "Inventory",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            }, {
                "name": "",
                "tableName": "IMLOCATION",
                "label": "Pieces",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            }, {
                "name": "",
                "tableName": "IMLOCATION",
                "label": "Units/Pkg",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            }, {
                "name": "",
                "tableName": "IMLOCATION",
                "label": "Pkg/Ship",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            }, {
                "name": "",
                "tableName": "IMLOCATION",
                "label": "Gross Weight",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            }, {
                "name": "",
                "tableName": "IMLOCATION",
                "label": "Net Weight",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            }, {
                "name": "",
                "tableName": "IMLOCATION",
                "label": "Area",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            }, {
                "name": "",
                "tableName": "IMLOCATION",
                "label": "Volume",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
        ]
    }, {
        "groupId": 5,
        "label": "Available",
        "fields": [
            {
                "name": "",
                "tableName": "IMLOCATION",
                "label": "Inventory",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            }, {
                "name": "",
                "tableName": "IMLOCATION",
                "label": "Pieces",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            }, {
                "name": "",
                "tableName": "IMLOCATION",
                "label": "Units/Pkg",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            }, {
                "name": "",
                "tableName": "IMLOCATION",
                "label": "Pkg/Ship",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            }, {
                "name": "",
                "tableName": "IMLOCATION",
                "label": "Gross Weight",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            }, {
                "name": "",
                "tableName": "IMLOCATION",
                "label": "Net Weight",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            }, {
                "name": "",
                "tableName": "IMLOCATION",
                "label": "Area",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            }, {
                "name": "",
                "tableName": "IMLOCATION",
                "label": "Volume",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true
            },
        ]
    }
];
const UserDefinedFormLayoutCodes = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "UserDefinedCode1",
                "tableName": "IMLOCATION",
                "label": "Code-1",
                "type": "lookup",
                layout: WMCodesLookupLayout({ codeType: '74' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode2",
                "tableName": "IMLOCATION",
                "label": "Code-2",
                "type": "lookup",
                layout: WMCodesLookupLayout({ codeType: '75' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "UserDefinedCode3",
                "tableName": "IMLOCATION",
                "label": "Code-3",
                "type": "lookup",
                layout: WMCodesLookupLayout({ codeType: '76' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "UserDefinedCode4",
                "tableName": "IMLOCATION",
                "label": "Code-4",
                "type": "lookup",
                layout: WMCodesLookupLayout({ codeType: '77' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "UserDefinedCode5",
                "tableName": "IMLOCATION",
                "label": "Code-5",
                "type": "lookup",
                layout: WMCodesLookupLayout({ codeType: '78' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "UserDefinedCode6",
                "tableName": "IMLOCATION",
                "label": "Code-6",
                "type": "lookup",
                layout: WMCodesLookupLayout({ codeType: '79' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "UserDefinedCode7",
                "tableName": "IMLOCATION",
                "label": "Code-7",
                "type": "lookup",
                layout: WMCodesLookupLayout({ codeType: '80' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "UserDefinedCode8",
                "tableName": "IMLOCATION",
                "label": "Code-8",
                "type": "lookup",
                layout: WMCodesLookupLayout({ codeType: '81' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "UserDefinedCode9",
                "tableName": "IMLOCATION",
                "label": "Code-9",
                "type": "lookup",
                layout: WMCodesLookupLayout({ codeType: '82' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "UserDefinedCode10",
                "tableName": "IMLOCATION",
                "label": "Code-10",
                "type": "lookup",
                layout: WMCodesLookupLayout({ codeType: '83' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }, {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "UserDefinedDate1",
                "tableName": "IDCUSTOMER",
                "label": "Date 1",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate2",
                "tableName": "IDCUSTOMER",
                "label": "Date 2",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate3",
                "tableName": "IDCUSTOMER",
                "label": "Date 3",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate4",
                "tableName": "IDCUSTOMER",
                "label": "Date 4",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate5",
                "tableName": "IDCUSTOMER",
                "label": "Date 5",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate6",
                "tableName": "IDCUSTOMER",
                "label": "Date 6",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate7",
                "tableName": "IDCUSTOMER",
                "label": "Date 7",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate8",
                "tableName": "IDCUSTOMER",
                "label": "Date 8",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate9",
                "tableName": "IDCUSTOMER",
                "label": "Date 9",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate10",
                "tableName": "IDCUSTOMER",
                "label": "Date 10",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    }, {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "UserDefinedQuantity1",
                "tableName": "IMLOCATION",
                "label": "Quantity 1",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity2",
                "tableName": "IMLOCATION",
                "label": "Quantity 2",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity3",
                "tableName": "IMLOCATION",
                "label": "Quantity 3",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity4",
                "tableName": "IMLOCATION",
                "label": "Quantity 4",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity5",
                "tableName": "IMLOCATION",
                "label": "Quantity 5",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity6",
                "tableName": "IMLOCATION",
                "label": "Quantity 6",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity7",
                "tableName": "IMLOCATION",
                "label": "Quantity 7",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity8",
                "tableName": "IMLOCATION",
                "label": "Quantity 8",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity9",
                "tableName": "IMLOCATION",
                "label": "Quantity 9",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity10",
                "tableName": "IMLOCATION",
                "label": "Quantity 10",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    }
];
const UserDefinedFormLayoutReference = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "UserDefinedReference1",
                "tableName": "IMLOCATION",
                "label": "Reference 1",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference2",
                "tableName": "IMLOCATION",
                "label": "Reference 2",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "UserDefinedReference3",
                "tableName": "IMLOCATION",
                "label": "Reference 3",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "UserDefinedReference4",
                "tableName": "IMLOCATION",
                "label": "Reference 4",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "UserDefinedReference5",
                "tableName": "IMLOCATION",
                "label": "Reference 5",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "UserDefinedReference6",
                "tableName": "IMLOCATION",
                "label": "Reference 6",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "UserDefinedReference7",
                "tableName": "IMLOCATION",
                "label": "Reference 7",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "UserDefinedReference8",
                "tableName": "IMLOCATION",
                "label": "Reference 8",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "UserDefinedReference9",
                "tableName": "IMLOCATION",
                "label": "Reference 9",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "UserDefinedReference10",
                "tableName": "IMLOCATION",
                "label": "Reference 10",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
];
const IMPrimaryLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "Record",
                "tableName": "IMLOCATION",
                "label": "Record #",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },
            {
                "name": "RProfile",
                "tableName": "IMLOCATION",
                "label": "Profile",
                "type": "lookup",
                layout: LocationDpLookupLayout({moduleType: IM}),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RWarehouse",
                "tableName": "IMLOCATION",
                "label": "Warehouse",
                "type": "lookup",
                layout: IDWarehouseLookupLayout,
                "lookupDisplayMode": "grid",
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "LocationCode",
                "tableName": "IMLOCATION",
                "label": "Location",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "Description",
                "tableName": "IMLOCATION",
                "label": "Description",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "Status",
                "tableName": "IMLOCATION",
                "label": "Status",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "LocationType",
                "tableName": "IMLOCATION",
                "label": "Location Type",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "RLocation",
                "tableName": "IMLOCATION",
                "label": "Parent Location",
                "type": "lookup",
                layout: locationLookupLayout,
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "Priority",
                "tableName": "IMLOCATION",
                "label": "Priority",
                "type": "lookup",
                layout: CodeLookupLayout({ codeType: '09' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "searchEnabled": true,
                "acceptCustomValue": true,
            }, {
                "name": "ClassCode",
                "tableName": "IMLOCATION",
                "label": "Class",
                "type": "lookup",
                layout: CodeLookupLayout({ codeType: '26' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "acceptCustomValue": true,
            }, {
                "name": "SubClassCode",
                "tableName": "IMLOCATION",
                "label": "Sub Class",
                "type": "lookup",
                layout: CodeLookupLayout({ codeType: '27' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "acceptCustomValue": true,
            }, {
                "name": "PickSequence",
                "tableName": "IMLOCATION",
                "label": "Pick Seq",
                "type": "number",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "Comment",
                "tableName": "IMLOCATION",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    }
]
const IMUserDefinedFormLayoutCodes = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "UserDefinedCode1",
                "tableName": "IMLOCATION",
                "label": "Code-1",
                "type": "lookup",
                layout: CodeLookupLayout({ codeType: '78' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode2",
                "tableName": "IMLOCATION",
                "label": "Code-2",
                "type": "lookup",
                layout: CodeLookupLayout({ codeType: '79' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "UserDefinedCode3",
                "tableName": "IMLOCATION",
                "label": "Code-3",
                "type": "lookup",
                layout: CodeLookupLayout({ codeType: '80' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "UserDefinedCode4",
                "tableName": "IMLOCATION",
                "label": "Code-4",
                "type": "lookup",
                layout: CodeLookupLayout({ codeType: '81' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "UserDefinedCode5",
                "tableName": "IMLOCATION",
                "label": "Code-5",
                "type": "lookup",
                layout: CodeLookupLayout({ codeType: '82' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "UserDefinedCode6",
                "tableName": "IMLOCATION",
                "label": "Code-6",
                "type": "lookup",
                layout: CodeLookupLayout({ codeType: '83' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "UserDefinedCode7",
                "tableName": "IMLOCATION",
                "label": "Code-7",
                "type": "lookup",
                layout: CodeLookupLayout({ codeType: '84' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "UserDefinedCode8",
                "tableName": "IMLOCATION",
                "label": "Code-8",
                "type": "lookup",
                layout: CodeLookupLayout({ codeType: '85' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "UserDefinedCode9",
                "tableName": "IMLOCATION",
                "label": "Code-9",
                "type": "lookup",
                layout: CodeLookupLayout({ codeType: '86' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "UserDefinedCode10",
                "tableName": "IMLOCATION",
                "label": "Code-10",
                "type": "lookup",
                layout: CodeLookupLayout({ codeType: '87' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }, {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "UserDefinedDate1",
                "tableName": "IDCUSTOMER",
                "label": "Date 1",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate2",
                "tableName": "IDCUSTOMER",
                "label": "Date 2",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate3",
                "tableName": "IDCUSTOMER",
                "label": "Date 3",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate4",
                "tableName": "IDCUSTOMER",
                "label": "Date 4",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate5",
                "tableName": "IDCUSTOMER",
                "label": "Date 5",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate6",
                "tableName": "IDCUSTOMER",
                "label": "Date 6",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate7",
                "tableName": "IDCUSTOMER",
                "label": "Date 7",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate8",
                "tableName": "IDCUSTOMER",
                "label": "Date 8",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate9",
                "tableName": "IDCUSTOMER",
                "label": "Date 9",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate10",
                "tableName": "IDCUSTOMER",
                "label": "Date 10",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    }, {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "UserDefinedQuantity1",
                "tableName": "IMLOCATION",
                "label": "Quantity 1",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity2",
                "tableName": "IMLOCATION",
                "label": "Quantity 2",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity3",
                "tableName": "IMLOCATION",
                "label": "Quantity 3",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity4",
                "tableName": "IMLOCATION",
                "label": "Quantity 4",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity5",
                "tableName": "IMLOCATION",
                "label": "Quantity 5",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity6",
                "tableName": "IMLOCATION",
                "label": "Quantity 6",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity7",
                "tableName": "IMLOCATION",
                "label": "Quantity 7",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity8",
                "tableName": "IMLOCATION",
                "label": "Quantity 8",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity9",
                "tableName": "IMLOCATION",
                "label": "Quantity 9",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity10",
                "tableName": "IMLOCATION",
                "label": "Quantity 10",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    }
];
export {
    SearchLayout,
    PrimaryLayout,
    DimensionTabLayout,
    UserDefinedFormLayoutCodes,
    UserDefinedFormLayoutReference,
    IMPrimaryLayout,
    IMUserDefinedFormLayoutCodes
}